const Header = () => {
  return (
    <header>
        <div className="pb-3 mb-4">
            <a href="/" className="">
                <img className="logo" alt="sodabits logo" src="/island/sodabit-island-header.jpg" />
            </a>
        </div>
    </header>
  );
};

export default Header;
